// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__cFcln","dots":"style_dots__tqXZN","dotsInner":"style_dotsInner__mRHWO"};